import React from "react";
import { FutureOrderList } from "../../components/FutureOrderList";

const ScheduledOrderIndex: React.FunctionComponent = () => {
  return <FutureOrderList queryVariables={{}} />;
};
export default ScheduledOrderIndex;
